import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import UISelectableButton from 'UIComponents/button/UISelectableButton';
import { getPatternUrl, PATTERNS } from '../utils/templateHeaderPatternUtils';
import { EMPTY_STRING } from '../../constants/SharedConstants';
import { getGradientSecondaryColor, getLinearGradientStyle, GRADIENT_TYPE } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatternList = styled.ul.withConfig({
  displayName: "PatternField__PatternList",
  componentId: "d99hoh-0"
})(["list-style:none;padding:0;"]);
const PatternListItem = styled.ul.withConfig({
  displayName: "PatternField__PatternListItem",
  componentId: "d99hoh-1"
})(["padding:0;margin:0;"]);
const Button = styled(UISelectableButton).withConfig({
  displayName: "PatternField__Button",
  componentId: "d99hoh-2"
})(["border-radius:3px;margin-bottom:10px;height:128px;width:100%;&&&{max-width:100%;}"]);
const PatternButton = styled(Button).withConfig({
  displayName: "PatternField__PatternButton",
  componentId: "d99hoh-3"
})(["background-image:url(", ");background-size:auto 100%;&&&{background-color:", ";}"], props => props.patternurl, props => props.color);
const GradientButton = styled(Button).withConfig({
  displayName: "PatternField__GradientButton",
  componentId: "d99hoh-4"
})(["background-image:", ";&&&{background-color:", ";}"], props => props.backgroundImage, props => props.backgroundColor);
class PatternField extends Component {
  constructor(...args) {
    super(...args);
    this.getOnChange = value => () => this.props.onFieldChange(value);
  }
  render() {
    const {
      color,
      gradientType,
      imageSrc,
      readOnly
    } = this.props;
    return /*#__PURE__*/_jsxs(PatternList, {
      children: [/*#__PURE__*/_jsx(PatternListItem, {
        children: /*#__PURE__*/_jsx(PatternButton, {
          color: color,
          selected: !gradientType && !imageSrc,
          onSelectedChange: this.getOnChange({
            gradientType: undefined,
            imageSrc: EMPTY_STRING
          }),
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx(PatternListItem, {
        children: /*#__PURE__*/_jsx(GradientButton
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        , {
          backgroundColor: getGradientSecondaryColor(GRADIENT_TYPE.LIGHT),
          backgroundImage: getLinearGradientStyle(GRADIENT_TYPE.LIGHT, color),
          selected: gradientType === GRADIENT_TYPE.LIGHT,
          onSelectedChange: this.getOnChange({
            gradientType: GRADIENT_TYPE.LIGHT,
            imageSrc: undefined
          }),
          readOnly: readOnly
        })
      }), /*#__PURE__*/_jsx(PatternListItem, {
        children: /*#__PURE__*/_jsx(GradientButton
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        , {
          backgroundColor: getGradientSecondaryColor(GRADIENT_TYPE.DARK),
          backgroundImage: getLinearGradientStyle(GRADIENT_TYPE.DARK, color),
          selected: gradientType === GRADIENT_TYPE.DARK,
          onSelectedChange: this.getOnChange({
            gradientType: GRADIENT_TYPE.DARK,
            imageSrc: undefined
          }),
          readOnly: readOnly
        })
      }), PATTERNS.map((pattern, index) => {
        const valueToUse = getPatternUrl(pattern.value, color);
        return /*#__PURE__*/_jsx(PatternListItem, {
          children: /*#__PURE__*/_jsx(PatternButton, {
            color: color,
            name: pattern.patternName,
            patternurl: valueToUse,
            selected: imageSrc === valueToUse,
            onSelectedChange: this.getOnChange({
              gradientType: undefined,
              imageSrc: valueToUse
            }),
            readOnly: readOnly
          })
        }, index);
      })]
    });
  }
}
PatternField.propTypes = {
  color: PropTypes.string.isRequired,
  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  gradientType: PropTypes.oneOf[(GRADIENT_TYPE.DARK, GRADIENT_TYPE.LIGHT)],
  imageSrc: PropTypes.string,
  onFieldChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};
export default PatternField;